<template>
    <svg id="access_control" viewBox="0 0 200 139.28" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
            <linearGradient id="a" x1="13.09" x2="195.84" y1="138.86" y2="6.69" gradientUnits="userSpaceOnUse">
                <stop stop-color="#ff34db" offset="0"/>
                <stop stop-color="#f835da" offset=".09"/>
                <stop stop-color="#e537d9" offset=".22"/>
                <stop stop-color="#c63bd6" offset=".37"/>
                <stop stop-color="#9a40d1" offset=".53"/>
                <stop stop-color="#6247cc" offset=".72"/>
                <stop stop-color="#1f4fc6" offset=".91"/>
                <stop stop-color="#0053c3" offset=".99"/>
            </linearGradient>
            <linearGradient id="g" x1="25.04" x2="207.78" y1="155.38" y2="23.2" xlink:href="#a"/>
            <linearGradient id="f" x1="26.99" x2="209.74" y1="158.07" y2="25.9" xlink:href="#a"/>
            <linearGradient id="e" x1="15.16" x2="197.9" y1="141.71" y2="9.54" xlink:href="#a"/>
            <linearGradient id="d" x1="-2.43" x2="180.32" y1="117.4" y2="-14.77" xlink:href="#a"/>
            <linearGradient id="c" x1="-18.85" x2="163.9" y1="94.7" y2="-37.47" xlink:href="#a"/>
            <linearGradient id="b" x1="-9.5" x2="173.25" y1="107.63" y2="-24.55" xlink:href="#a"/>
            <linearGradient id="k" x1="-.14" x2="182.6" y1="120.56" y2="-11.62" xlink:href="#a"/>
            <linearGradient id="j" x1="8.45" x2="191.19" y1="132.44" y2=".26" xlink:href="#a"/>
            <linearGradient id="i" x1="13.35" x2="196.09" y1="139.21" y2="7.04" xlink:href="#a"/>
            <linearGradient id="h" x1="17.89" x2="200.63" y1="145.49" y2="13.32" xlink:href="#a"/>
        </defs>
        <title>Asset 25</title>
        <g data-name="Layer 2">
            <g data-name="Layer 2">
                <path class="cls-1" d="M189.42,0H55A10.58,10.58,0,0,0,44.4,10.58V43.45a2.39,2.39,0,0,0,2.39,2.39h0a2.38,2.38,0,0,0,2.38-2.39V10.58A5.81,5.81,0,0,1,55,4.77H189.42a5.82,5.82,0,0,1,5.81,5.81V83.87H44.4v11A10.58,10.58,0,0,0,55,105.41h49.8v19.17a10,10,0,0,1-9.93,10H79.12a2.37,2.37,0,0,0,0,4.74h86.13a2.37,2.37,0,1,0,0-4.74h-15.7a10,10,0,0,1-10-10V105.41h49.83A10.6,10.6,0,0,0,200,94.83V10.58A10.6,10.6,0,0,0,189.42,0ZM105.66,134.54a14.76,14.76,0,0,0,3.89-10V105.41h25.31v19.17a14.73,14.73,0,0,0,3.86,10Zm89.57-39.71a5.83,5.83,0,0,1-5.81,5.81H55a5.81,5.81,0,0,1-5.81-5.81v-6.2H195.23Z"/>
                <path class="cls-2" d="M170.84,49.63a4.46,4.46,0,0,1-2.59,4.07v7a.42.42,0,0,1-.41.42h-3a.42.42,0,0,1-.42-.42v-7a4.45,4.45,0,0,1-2.58-4.07,4.51,4.51,0,1,1,9,0Z"/>
                <path class="cls-3" d="M177,80.07H153.34a10.64,10.64,0,0,1-10.63-10.63V46.83A10.64,10.64,0,0,1,153.34,36.2H177a10.64,10.64,0,0,1,10.63,10.63V69.44A10.64,10.64,0,0,1,177,80.07Zm-23.66-39a5.76,5.76,0,0,0-5.75,5.75V69.44a5.76,5.76,0,0,0,5.75,5.75H177a5.75,5.75,0,0,0,5.74-5.75V46.83A5.75,5.75,0,0,0,177,41.08Z"/>
                <path class="cls-4" d="M176.3,38.64h-4.89V31.05H158.92v7.59H154V29.46a3.29,3.29,0,0,1,3.29-3.29H173a3.29,3.29,0,0,1,3.3,3.29Z"/>
                <path class="cls-5" d="M135.21,78.44H4.11A4.12,4.12,0,0,1,0,74.33V56.19a4.12,4.12,0,0,1,4.11-4.11h131.1a4.12,4.12,0,0,1,4.11,4.11V74.33A4.12,4.12,0,0,1,135.21,78.44ZM4.88,73.55H134.44V57H4.88Z"/>
                <path class="cls-6" d="m18.21 71.35a2.45 2.45 0 0 1-1.73-4.17l7.29-7.29a2.44 2.44 0 0 1 3.46 3.45l-7.3 7.29a2.41 2.41 0 0 1-1.72 0.72z"/>
                <path class="cls-7" d="M25.5,71.35a2.45,2.45,0,0,1-1.73-.72l-7.29-7.29a2.44,2.44,0,1,1,3.45-3.45l7.3,7.29a2.45,2.45,0,0,1-1.73,4.17Z"/>
                <path class="cls-8" d="m45.43 71.35a2.45 2.45 0 0 1-1.72-4.17l7.29-7.29a2.44 2.44 0 0 1 3.45 3.45l-7.29 7.29a2.43 2.43 0 0 1-1.73 0.72z"/>
                <path class="cls-8" d="M52.73,71.35A2.43,2.43,0,0,1,51,70.63l-7.29-7.29a2.44,2.44,0,0,1,3.45-3.45l7.29,7.29a2.45,2.45,0,0,1-1.72,4.17Z"/>
                <path class="cls-9" d="m72.66 71.35a2.45 2.45 0 0 1-1.73-4.17l7.3-7.29a2.44 2.44 0 1 1 3.45 3.45l-7.29 7.29a2.43 2.43 0 0 1-1.73 0.72z"/>
                <path class="cls-9" d="M80,71.35a2.41,2.41,0,0,1-1.72-.72l-7.3-7.29a2.44,2.44,0,1,1,3.46-3.45l7.29,7.29A2.45,2.45,0,0,1,80,71.35Z"/>
                <path class="cls-10" d="m96.77 66.19a2.37 2.37 0 1 0 2.37 2.37 2.37 2.37 0 0 0-2.37-2.37z"/>
                <path class="cls-11" d="m111 66.19a2.37 2.37 0 1 0 2.37 2.37 2.37 2.37 0 0 0-2.37-2.37z"/>
                <path class="cls-12" d="m124.26 66.19a2.37 2.37 0 1 0 2.37 2.37 2.37 2.37 0 0 0-2.37-2.37z"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "svg_accesscontrol"
    }
</script>

<style lang="scss" scoped>
    #access_control{
        .cls-1{fill:url(#a);}
        .cls-2{fill:url(#g);}
        .cls-3{fill:url(#f);}
        .cls-4{fill:url(#e);}
        .cls-5{fill:url(#d);}
        .cls-6{fill:url(#c);}
        .cls-7{fill:url(#linear-gradient-7);}
        .cls-8{fill:url(#b);}
        .cls-9{fill:url(#k);}
        .cls-10{fill:url(#j);}
        .cls-11{fill:url(#i);}
        .cls-12{fill:url(#h);}
    }
</style>